import type { FC } from "react"

import { PaymentTermsDisplay } from "./PaymentTermsDisplay"

interface SensitiveAccountItemProps {
  sensitiveAccount: boolean | null
}

export const SensitiveAccountItem: FC<SensitiveAccountItemProps> = ({ sensitiveAccount }) => {
  const value = sensitiveAccount === null ? "" : sensitiveAccount ? "Yes" : "No"

  return <PaymentTermsDisplay name='Sensitive Account' value={value} />
}
